import { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { adminAPI, appointmentAPI } from '@/lib/api';
import {
  LayoutDashboard,
  FileText,
  Briefcase,
  Calendar,
  LogOut,
  Eye
} from 'lucide-react';

const AdminDashboard = () => {

  const [stats, setStats] = useState(null);
  const [appointments, setAppointments] = useState([]);

  const navigate = useNavigate();

  /* ================= AUTH ================= */

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (!token) navigate('/admin/login');
    else {
      fetchStats();
      fetchAppointments();
    }
  }, [navigate]);

  /* ================= FETCH ================= */

  const fetchStats = async () => {
    try {
      const response = await adminAPI.getStats();
      setStats(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAppointments = async () => {
    try {
      const response = await appointmentAPI.getAll();
      setAppointments(response.data.slice(0, 10)); // son 10
    } catch (error) {
      console.error(error);
    }
  };

  /* ================= LOGOUT ================= */

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_email');
    navigate('/admin/login');
  };

  /* ================= UI ================= */

  return (
    <div className="min-h-screen bg-light">

      {/* NAVBAR */}
      <nav className="bg-navy text-white p-6">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <h1 className="text-2xl font-bold">Admin Panel</h1>

          <button
            onClick={handleLogout}
            className="flex items-center space-x-2 hover:text-orange transition"
          >
            <LogOut size={20} />
            <span>Çıkış</span>
          </button>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-6 py-12">

        {/* ================= STATS ================= */}

        <div className="grid md:grid-cols-4 gap-6 mb-12">

          <Stat
            icon={<FileText />}
            value={stats?.total_blogs || 0}
            label="Blog Yazısı"
          />

          <Stat
            icon={<Briefcase />}
            value={stats?.total_projects || 0}
            label="Proje"
          />

          <Stat
            icon={<Calendar />}
            value={stats?.total_appointments || 0}
            label="Randevu"
          />

          <Stat
            icon={<Calendar />}
            value={stats?.pending_appointments || 0}
            label="Bekleyen"
          />

        </div>

        {/* ================= NAV ================= */}

        <div className="grid md:grid-cols-4 gap-6 mb-12">

          <NavCard
            to="/admin/blog"
            icon={<FileText size={48} />}
            title="Blog Yönetimi"
          />

          <NavCard
            to="/admin/islerimiz"
            icon={<Briefcase size={48} />}
            title="İşlerimiz Yönetimi"
          />

          <NavCard
            to="/admin/randevular"
            icon={<Calendar size={48} />}
            title="Randevu Yönetimi"
          />

          <NavCard
            to="/admin/anketler"
            icon={<Eye size={48} />}
            title="Anket Yönetimi"
          />

        </div>
      </div>
    </div>
  );
};

/* ================= COMPONENTS ================= */

const Stat = ({ icon, value, label }) => (
  <div className="bg-white p-6 rounded-lg shadow-sm text-center">
    <div className="text-orange mb-2 flex justify-center">
      {icon}
    </div>
    <p className="text-3xl font-bold text-navy">{value}</p>
    <p className="text-slate-600">{label}</p>
  </div>
);

const NavCard = ({ to, icon, title }) => (
  <Link
    to={to}
    className="bg-white p-8 rounded-lg shadow-sm hover:shadow-md transition text-center"
  >
    <div className="mx-auto text-orange mb-4">
      {icon}
    </div>
    <h3 className="text-xl font-bold text-navy">
      {title}
    </h3>
  </Link>
);

export default AdminDashboard;
